import {Moment} from "moment-timezone";
import {MomentAdapter, MomentUtils} from "./moment.utils";

export class BirthDateUtils {

    public static calculateAge(birthDate: Moment): number {
        let timeDiff = Math.abs(MomentUtils.difference(MomentAdapter.current().get(), birthDate));
        return Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
    }
}